<template>
  <div class="headStyle">
    <div class="firstRowStyle">
      <div class="systemStyle">

        <div>成绩发布平台</div>
        <div class="systemStyle">
          <div style="font-size: 16px;">导成绩不用模板,查成绩不装软件。查完即锁,保护隐私!</div>
        </div>
      </div>
<!--      <div @click="openEmployee"
        style="display: flex;align-items: center;font-size: 20px;color:red;text-decoration: underline;">
        招聘自媒体兼职运营老师,点我了解
      </div> -->
      <div class="infoActionStyle">
        <el-button type="text" size="medium" @click="editProfile('school_name')">
          学校：<span style="text-decoration: underline;">{{school}}</span>
        </el-button>
        <el-button type="text" size="medium" @click="editProfile('teacher_name')">
          姓名：<span style="text-decoration: underline;">{{teacher_name}}</span>
        </el-button>
        <el-button type="text" size="medium">
          账号：{{username}}
        </el-button>
        <el-button @click="helpMe" type="text" size="medium">
          <span style="text-decoration: underline;">使用帮助</span>
        </el-button>
        <el-button @click="logout" type="text" size="medium">
          <span style="text-decoration: underline;">退出</span>
        </el-button>
      </div>
    </div>
    <div>

      <el-dialog width="25%" :close-on-click-modal="false" title="修改用户资料" :visible.sync="editDialogVisible">
        <!-- <el-form-item label="卷面分"> -->
        <div class="colStyle">
          <div class="rowStyle">
            <div class="rowStyle" style="padding-right: 10px;white-space:nowrap;">
              <div>{{lable}}</div>
            </div>
            <div>
              <el-input v-model="content" autocomplete="off" placeholder="数字,如150" autofocus></el-input>
            </div>
          </div>
        </div>

        <!-- </el-form-item> -->

        <div slot="footer" class="dialog-footer">
          <el-button @click="cacelEdit">取 消</el-button>
          <el-button type="primary" @click="saveContent">保 存</el-button>
        </div>
      </el-dialog>

      <!--招聘广告-->
      <el-dialog width="60%" :close-on-click-modal="false" title="招聘兼职老师" :visible.sync="employeeDialogVisible">
        <div class="colStyle">
          <div class="rowStyle">
            <div style="font-size: 16px;">
              <div>
                招聘自媒体、公众号运营的兼职老师2-3人，主要负责我们产品的公众号内容发布、小视频制作，以及文案等工作。待遇为底薪+奖金。
              </div>
              <div>
                <br />工作时间地点在家，按时间完成工作即可。不会做，我们可以培训。
                <br />工作态度好，有团队协作精神。自己有电脑，有时间做兼职工作。
              </div>
              <div>
                <div>有意者请扫码加微信沟通：</div>
                <div><img src="/score/images/contact_weixin.jpg" style="height: 200px;" /></div>
              </div>


            </div>
            <div>
            </div>
          </div>
        </div>

        <!-- </el-form-item> -->

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="employeeDialogVisible=false">关 闭</el-button>
        </div>
      </el-dialog>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        username: '',
        teacher_name: '',
        school: '',
        content: '',
        lable: '',
        source: '',
        editDialogVisible: false,
        url: this.HOST_URL + '/images/logo.jpg',
        employeeDialogVisible: false,
        contact_weix: this.HOST_URL + '/images/contact_weixin.jpg',
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.teacher_name = this.$session.get('TEACHER_NAME') // 获取session
      this.school = this.$session.get('SCHOOL') // 获取session
    },
    mounted() {
      console.log('monted:' + this.username)
      if (this.isEmpty(this.username)) {
        this.$router.push('/')
      }
    },
    methods: {
      logout() {
        let that = this

        this.$confirm('要退出系统吗?', '提示', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/score/web/_logout.jsp'
          this.axios.get(requestUrl, {
              params: {}
            }).then(function(response) {
              that.$router.push('/')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      helpMe() {
        const {
          href
        } = this.$router.resolve({
          name: 'help'
        })
        window.open(href, '_blank')
      },
      editProfile(source) {
        if (source === 'school_name') {
          this.content = this.school
          this.lable = '学校'
          this.source = 'school_name'
        } else {
          this.content = this.teacher_name
          this.lable = '姓名'
          this.source = 'teacher_name'
        }

        this.editDialogVisible = true
      },
      cacelEdit() {
        this.editDialogVisible = false
      },
      saveContent() {
        // 校验
        if (this.content === '') {
          this.$message.error('内容不能为空！')
          return
        }

        let that = this
        var requestUrl = '/score/web/_update_profile.jsp'

        if (this.source === 'school_name') {
          this.school = this.content
          that.$session.set('SCHOOL', this.content) // 存session
        } else {
          this.teacher_name = this.content
          that.$session.set('TEACHER_NAME', this.content) // 存session
        }

        // 设置session

        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              content: that.content,
              source: that.source
            }
          }).then(function(response) {
            // that.columNames.push(...response.data)
            that.content = ''
            that.editDialogVisible = false
            that.$message('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      openEmployee() {
        this.employeeDialogVisible = true
      }

    }
  }
</script>

<style>
  .headStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1upx solid #E9ECF1;
    background-color: aliceblue;

  }

  .firstRowStyle {
    display: flex;
    justify-content: space-between;
    /* background-color: #f2f2f2; */
    width: 99%;
  }

  .systemStyle {
    display: flex;
    font-size: 30px;
    padding: 20px;
    font-weight: bold;
  }

  .infoActionStyle {
    display: flex;
    padding-right: 20px;
    align-items: center;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/head.vue